import React, { FC, useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../Button/Button";
import { ExpandRowDetailsProps, PropsFromScreenManager } from "../../../types";
import classes from "./ExpandRowDetails.module.css";
import placeholder from "../../../Utils/images/placeholder.png";
import { recentDataSuccess, toggleScrollTop } from "../../../action/TableAction";
import { connect, ConnectedProps } from "react-redux";
import { getBuildSearchParams } from "../../../Utils/general";

const mapDispatchToProps = {
  recentDataSuccess,
  toggleScrollTop,
};
const connector = connect(null, mapDispatchToProps);
export type PropsFromRowDetailsRedux = ConnectedProps<typeof connector>;
const ExpandRowDetails: FC<ExpandRowDetailsProps & PropsFromScreenManager> = (
  props
) => {
  const {
    row,
    recentDataSuccess,
    instanceData: { screenManager },
    toggleScrollTop,
    onSelectDiamond,
  } = props;
  const isMobileView = useMediaQuery({ query: "(max-width: 991px)" });
  const {
    image_link,
    carat,
    source: rowSource,
    shape,
    cut,
    clarity,
    color,
    certification,
    fluorecence,
    polish,
    symmetry,
    b2c_price: diamond_b2c_price,
  } = row;

  const pathChange = (path: string, styleId?: string | null, id?: string) => {
    if ((screenManager as any).changeScreen) {
      (screenManager as any).changeScreen({
        viewName:     path,
        styleId:      styleId,
        id:           id,
        searchParams: getBuildSearchParams(window.location)
      });
    }
  };

  const handleViewDiamondDetail = useCallback(
    (row: typeof props.row) => {
      recentDataSuccess(row);
      pathChange("details", null, row.id as string);
      toggleScrollTop(true);
    },
    [ recentDataSuccess, pathChange, toggleScrollTop ]
  );

  const image = (
    <div className={classes.container}>
      <div
        className={classes.img}
        style={{
          backgroundImage: `url(${image_link ? image_link : placeholder})`,
        }}
        aria-label="Product Image"
      />
    </div>
  );

  if (isMobileView) {
    return (
      <div className={classes.root}>
        <h2 className={`hk_detailHeading ${classes.mobileTitle}`}>
          <span>{`${carat} ct. ${shape} ${rowSource} Diamond`}</span>
        </h2>
        <div className={classes.mobileRow}>
          {image}
          <div className={`${classes.info} hk_detailsContainer`}>
            <Button
              type={"button"}
              buttonType={"btnPrimary"}
              className={`${classes.detailButton} rb-track-select-diamond`}
              data-rb-diamond-id={row.id as string}
              data-rb-price={diamond_b2c_price as number}
              data-name={`${carat}ct. ${shape} ${color} ${clarity}`}
              data-rb-payload={JSON.stringify({
                id:    row.id,
                name:  `${carat}ct. ${shape} ${color} ${clarity}`,
                price: +(diamond_b2c_price as number),
              })}
              onClick={() => onSelectDiamond?.(row)}
            >
              <span className={classes.detailButtonText}>Select This Diamond</span>
            </Button>
            <div className={"hk_details_wrap"}>
              <div className={"hk_detail"}>
                <span>Shape</span>
                <span className={"hk_detail_val"}>{shape}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Type</span>
                <span className={"hk_detail_val"}>{rowSource}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Cut</span>
                <span className={"hk_detail_val"}>{cut}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Certification</span>
                <span className={"hk_detail_val"}>{certification}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Fluorescence</span>
                <span className={"hk_detail_val"}>{fluorecence}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Polish</span>
                <span className={"hk_detail_val"}>{polish}</span>
              </div>
              <div className={"hk_detail"}>
                <span>Symmetry</span>
                <span className={"hk_detail_val"}>{symmetry}</span>
              </div>
            </div>
            <button
              type={"button"}
              className={classes.viewMoreLink}
              onClick={() => handleViewDiamondDetail(row)}
            >
              View More Details
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {image}
      <div className={`${classes.info} hk_detailsContainer`}>
        <h2 className={"hk_detailHeading"}>
          <span>{`${carat} ct. ${shape} ${rowSource} Diamond`}</span>
        </h2>
        <div className={"hk_details_wrap"}>
          <div className={"hk_detail"}>
            <span>Fluorescence</span>
            <span className={"hk_detail_val"}>{fluorecence}</span>
          </div>
          <div className={"hk_detail"}>
            <span>Polish</span>
            <span className={"hk_detail_val"}>{polish}</span>
          </div>
          <div className={"hk_detail"}>
            <span>Symmetry</span>
            <span className={"hk_detail_val"}>{symmetry}</span>
          </div>
        </div>
        <Button
          type={"button"}
          buttonType={"btnSecondary"}
          className={classes.detailButton}
          onClick={() => handleViewDiamondDetail(row)}
        >
          <span>View More Details</span>
        </Button>
      </div>
    </div>
  );
};

export default connector(ExpandRowDetails);
